<template>
    <div
        class="mx-0 d-flex"
        :class="{
            'articleList-m': type === 'm',
            'articleList-s': type === 's',
            'articleList--border': type === 'border',
            noDate: noDate,
        }"
    >

        <div
            class="photo cursorPoint"
            @click="getArticleContent(article.contentSeq);"
            :style="{
                'background-image':
                    'url(' +
                    previewImage(article.previewImage) +
                    ')',
            }"
            :data-ga-element="`${gaInfo}${article.contentSeq}(預覽圖)`"
        />
        <div class="px-lg-3 px-2 pt-lg-2 py-1 articleText">
            <div class="text-right date pb-1">
                {{ article.onDate }}
            </div>
            <span
                class="contentCata d-block"
                v-if="article.categories"
            >
                <span v-if="article.categories.length>1">
                    {{ article.categories.join('/ ') }}
                </span>
                <span v-else>
                    {{ article.categories[0] }}
                </span>
            </span>
            <router-link
                :to="'/articlePage/' + article.contentSeq"
                :data-ga="`${gaInfo}${article.contentSeq}(標題)`"
            >
                <p class="contentTitle cursorPoint">
                    {{ article.contentTitle }}
                </p>
            </router-link>
            <p class="content">
                {{ article.previewContent }}
            </p>
            <InOrder
                v-if="isShowOrderNum"
                :index="index"
            />
            <ShareButtonRow
                class="mb-1"
                :articleId="article.contentId"
                :articleSeq="article.contentSeq"
                :data-ga="`${gaInfo}${article.contentSeq}(標題)`"
            />
        </div>

    </div>
</template>
<script>
import InOrder from './InOrder';
import ShareButtonRow from './ShareButtonRow.vue';
export default {
    name: 'ArticleList',
    components: { InOrder, ShareButtonRow },
    props: {
        article: {
            type: Object,
            require: true,
        },
        type: {
            type: String,
            default: 'm',
        },
        noDate: {
            type: Boolean,
            default: false,
        },
        isShowOrderNum: {
            type: Boolean,
            default: false,
        },
        index: {
            type: Number,
            require: false,
        },
        gaInfo: {
            type: String,
            default: '健康及保險知識+｜',
        },
    },
    methods: {
        getArticleContent(contentSeq) {
            this.$router.push({ name: 'articlePage', params: { articleId: contentSeq } }).catch(() => { });
        }
    }
};
</script>
<style lang="scss" scoped>
.articleList-s {
    line-height: 1;
    margin-bottom: 0.25rem;
    @include media-breakpoint-up(sm) {
        margin-bottom: 0.75rem;
    }
    @include media-breakpoint-up(md) {
        margin-bottom: 0.75rem;
    }
    @include media-breakpoint-up(lg) {
        // margin-bottom: 0.8rem;
    }
    &:hover {
        .contentTitle {
            @include media-breakpoint-up(lg) {
                color: $success;
            }
        }
    }

    .date {
        font-size: 0.75rem;
        color: $gray-400;
        margin-bottom: 5%;
        margin-top: 0.25rem;
        @include media-breakpoint-up(md) {
            margin-top: 2px;
            margin-bottom: 1%;
        }
        @include media-breakpoint-up(lg) {
            margin-bottom: 1%;
            margin-top: -0.25rem;
        }
    }
    .articleText {
        flex: 0 0 50%;
        max-width: 50%;
        @include media-breakpoint-up(lg) {
           flex: 0 0 57%;
           max-width: 57%;
        }
    }
    .photo {
        background-position: center center;
        background-size: cover;
        border: 0;
        background-repeat: no-repeat;
        flex: 0 0 50%;
        max-width: 50%;
        border-radius: $radius;
        background-color: #eee;
        // background-image: url("../assets/images/home/nopic2.jpg");
        @include media-breakpoint-up(lg) {
           flex: 0 0 43%;
           max-width: 43%;
        }
    }
    .contentCata {
        font-size: 0.875rem;
        // color: $gray-500;
        color: $deep-red;
        margin-bottom: 0.5rem;
        @extend %ellipsis-single;
        @include media-breakpoint-up(md) {
            margin-bottom: 0.25rem;
        }
        @include media-breakpoint-up(lg) {
            margin-bottom: 0.5rem;
            font-size: 0.875rem;
        }
    }
    .contentTitle {
        font-size: 1.25rem;
        margin-bottom: 0.5rem;
        font-weight: 600;
        @include ellipsis-multi(2);
        @include media-breakpoint-up(sm) {
           @include ellipsis-multi(1);
        }
        @include media-breakpoint-up(md) {
           margin-bottom: 0.25rem;
           @include ellipsis-multi(2);
        }
        @include media-breakpoint-up(lg) {
           @include ellipsis-multi(1);
        }
    }
    .content {
        height: 2rem;
        font-size: 0.875rem;
        margin-bottom: 0.5rem;
        position: relative;
        color: $gray-600;
        line-height: 1.25;
        display: none;
        @include media-breakpoint-up(sm) {
            height: 2.5rem;
            display: block;
            font-size: 1rem;
            margin-bottom: 10%;
            @include ellipsis-multi(2);
        }
        @include media-breakpoint-up(md) {
            display: none;
            height: 1.125rem;
            font-size: 0.875rem;
            margin-bottom: 0.5rem;
        }
        @include media-breakpoint-up(lg) {
            display: block;
            height: 2rem;
            @include ellipsis-multi(2);
        }
    }
}
.articleList-m {
    max-height: 13rem;
    line-height: 1;
    margin-bottom: 1rem;
    @include media-breakpoint-up(lg) {
        margin-bottom: 1.25rem;
    }
    &:hover {
        .contentTitle {
            @include media-breakpoint-up(lg) {
                color: $success;
            }
        }
    }
    .articleText {
        flex: 0 0 36.5%;
        max-width: 36.5%;
    }
    .date {
        font-size: 0.875rem;
        color: $gray-400;
        margin-bottom: 9%;
        margin-top: 0.25rem;
        @include media-breakpoint-up(md) {
            margin-bottom: 17%;
        }
        @include media-breakpoint-up(lg) {
            margin-bottom: 12%;
        }
    }
    .photo {
        background-position: center center;
        background-size: cover;
        border: 0;
        background-repeat: no-repeat;
        flex: 0 0 63.5%;
        max-width: 63.5%;
        border-radius: $radius;
        background-color: #eee;
        // background-image: url("../assets/images/home/nopic2.jpg");
    }
    .contentCata {
        font-size: 0.875rem;
        // color: $gray-500;
        color: $deep-red;
        margin-bottom: 0.5rem;
        @extend %ellipsis-single;
        @include media-breakpoint-up(lg) {
            font-size: 1rem;
        }
    }
    .contentTitle {
        font-size: 1.25rem;
        margin-bottom: 0.5rem;
        font-weight: 600;
        @extend %ellipsis-single;
    }
    .content {
        height: 2.1875rem;
        font-size: 0.875rem;
        margin-bottom: 1rem;
        color: $gray-600;
        position: relative;
        line-height: 1.25;
        @include ellipsis-multi(2);
        // &:after {
        //     content: '\02026';
        //     display: block;
        //     position: absolute;
        //     right: 0;
        //     bottom: 0;
        //     color: #333;
        //     background-color: #fff;
        //     padding: 0 0.2rem;
        // }
        @include media-breakpoint-up(lg) {
            height: 3.6rem;
            font-size: 1rem;
            -webkit-line-clamp: 3;
            margin-bottom: 1rem;
        }
    }
}
.articleList--border {
    max-height: 18rem;
    position: relative;
    border-radius: $radius;
    overflow: hidden;
    line-height: 1;
    margin-bottom: 1rem;
    @include media-breakpoint-up(lg) {
        margin-bottom: 1.25rem;
        border: 1px solid $gray-300;
    }
    &:hover {
        .contentTitle {
            @include media-breakpoint-up(lg) {
                color: $success;
            }
        }
    }
    .photo {
        background-position: center center;
        background-size: cover;
        border: 0;
        border-radius: $radius;
        background-repeat: no-repeat;
        flex: 0 0 50%;
        max-width: 50%;
        background-color: #eee;
        // background-image: url("../assets/images/home/nopic2.jpg");
        @include media-breakpoint-up(md) {
            flex: 0 0 50%;
            max-width: 50%;
        }
    }
    .articleText {
        flex: 0 0 50%;
        max-width: 50%;
        @include media-breakpoint-up(md) {
            flex: 0 0 50%;
            max-width: 50%;
        }
    }
    .date {
        font-size: 0.75rem;
        color: $gray-400;
        margin-bottom: 5%;
        margin-top: 0.25rem;
        @include media-breakpoint-up(sm) {
            font-size: 0.875rem;
            margin-bottom: 3%;
            margin-top: 0.5rem;
        }
        @include media-breakpoint-up(md) {
            margin-bottom: 9%;
        }
    }

    .contentCata {
        font-size: 0.875rem;
        // color: $gray-500;
        color: $deep-red;
        margin-bottom: 5%;
        @extend %ellipsis-single;
        // @include media-breakpoint-up(sm) {
        //     margin-bottom: 3%;
        //     margin-top: 0.5rem;
        // }
        @include media-breakpoint-up(lg) {
            font-size: 1rem;
        }
    }
    .contentTitle {
        font-size: 1.25rem;
        margin-bottom: 5%;
        min-height: 2.5rem;
        font-weight: 600;
        // @extend %ellipsis-single;
        @include ellipsis-multi(2);
        @include media-breakpoint-up(md) {
            min-height: 1.25rem;
            font-size: 1.5rem;
            margin-bottom: 3.5%;
            &:hover {
                color: $warning;
            }
        }
    }
    .content {
        display: none;
        height: 1.2rem;
        font-size: 0.875rem;
        margin-bottom: 1rem;
        color: $gray-600;
        position: relative;
        line-height: 1.25;
        @extend %ellipsis-single;
        @include media-breakpoint-up(sm) {
            display: block;
            @include ellipsis-multi(2);
            height: 2.1875rem;
            margin-bottom: 9%;
        }
        @include media-breakpoint-up(lg) {
            height: 3.6rem;
            font-size: 1rem;
            -webkit-line-clamp: 3;
            margin-bottom: 5%;
        }
    }
}
.noDate {
    .photo {
        flex: 0 0 58%;
        max-width: 58%;
        @include media-breakpoint-up(md) {
            flex: 0 0 42.5%;
            max-width: 42.5%;
        }
    }
    .articleText {
        flex: 0 0 42%;
        max-width: 42%;
        @include media-breakpoint-up(md) {
            flex: 0 0 57.5%;
            max-width: 57.5%;
        }
    }
    .date {
        display: none;
    }
    .contentCata {
        margin-top: 0.25rem;
        font-size: 0.875rem;
    }
    .content {
        margin-bottom: 0.25rem;
        font-size: 0.875rem;
        height: 2.1rem;
        @include ellipsis-multi(2);
    }
}
</style>
